export enum SSOErrorType {
  DISMISSABLE_ALERT = 0,
  OUTSIDE = 1,
  INLINE = 2,
  REDIRECT = 3
}
